import { google, ics, outlook } from "calendar-link";
import { Button } from "react-bootstrap";
import { PlusCircleIcon } from "@heroicons/react/outline";
import PropTypes from "prop-types";

const buttonClasses = "py-1 px-0 d-block text-start";
const calendarLinks = [
	{
		function: google,
		title: "Google Calendar"
	},
	{
		function: ics,
		title: "iCal Export"
	},
	{
		function: outlook,
		title: "Outlook"
	}
];

const CourseCalendarLinks = ({
	course
}) => {

	const event = {
		description: course.description,
		end: course.end.toISOString(),
		location: course.location?.name?.trim() || "",
		start: course.start.toISOString(),
		title: course.title
	};

	return (
		<>
			{calendarLinks.map((link) => (
				<Button className={buttonClasses} href={link.function(event)} key={link.title} variant="link">
					<PlusCircleIcon /> <span className="text-neutral2">{link.title}</span>
				</Button>
			))}
		</>
	);
};

CourseCalendarLinks.propTypes = {
	course: PropTypes.shape({
		description: PropTypes.string,
		end: PropTypes.instanceOf(Date),
		location: PropTypes.shape({
			name: PropTypes.string
		}),
		start: PropTypes.instanceOf(Date),
		title: PropTypes.string
	}).isRequired
};

export default CourseCalendarLinks;
